import { Component, Inject, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-reject-message',
  templateUrl: './dialog-reject-message.component.html',
  styleUrls: ['./dialog-reject-message.component.scss']
})
export class DialogRejectMessageComponent implements OnInit {
  showMessage: boolean = true;
  showReject: boolean = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<DialogRejectMessageComponent>) { }
  ngOnInit(): void {

  }

  cancel() {
    this.dialogRef.close();
    this.showMessage = false;
  }

  submit() {
    this.showMessage = false;
    this.showReject = true;
  }

  ok() {
    this.dialogRef.close();
  }
}
